import _ from "lodash";
import { action, reaction, extendObservable, computed } from "mobx";
import FormStore from "./formStore";

class GroundTruthStore extends FormStore {
  constructor(setiApi, routerStore) {
    super(routerStore);

    this.setiApi = setiApi;
    this.routerStore = routerStore;
    this.data = {};
    this.collectionDates = [];
    this.defaults = {
      venueId: "22",
      collectionDate: ""
    };

    extendObservable(this, {
      isLoadingPlotData: true,
      isLoadingCollectionDateData: true,
      isLoading: computed(
        () => this.isLoadingPlotData || this.isLoadingCollectionDateData
      ),
      formValues: {
        venueId: this.defaults["venueId"],
        collectionDate: this.defaults["collectionDate"]
      },
      fetchData: action((useCollectionDate = false) => {
        this.isLoadingPlotData = true;
        this.setiApi
          .fetchGroundTruthData(
            this.get("venueId"),
            useCollectionDate && this.get("collectionDate")
          )
          .then(data => {
            this.data = data;
            // This replace is temporary while the plotdata response still responds with the old date format.
            this.update("collectionDate")(
              data.collectionDate && data.collectionDate.replace(/-/g, "")
            );
            this.isLoadingPlotData = false;
          });

        // If we aren't using the collection date, we've changed venues
        // and need to fetch the new collection dates;
        if (!useCollectionDate) {
          this.isLoadingCollectionDateData = true;
          this.setiApi
            .fetchGroundTruthCollectionDateData(this.get("venueId"))
            .then(data => {
              this.collectionDates = data.collectionDates;
              this.isLoadingCollectionDateData = false;
            });
        }
      })
    });

    reaction(
      () => this.routerStore.location && this.routerStore.location.search,
      () => {
        if (this.routerStore.isGroundTruthTab) {
          this.updateFromUrlParams(this.routerStore.location.search);
          if (_.isEmpty(this.get("collectionDate"))) {
            this.fetchData();
          } else {
            this.fetchData(true);
          }
        }
      },
      true
    );
  }
}

export default GroundTruthStore;



// WEBPACK FOOTER //
// ./src/stores/groundTruthStore.js